import ApiService from './ApiService';

class AuthApi extends ApiService {

    login(payload) {
        return this.post('login', payload);
    }

    verifyOTP2FA(payload) {
        return this.post('auth/verify-otp', payload);
    }

    resendOTP2FA(payload) {
        return this.post('auth/resend-otp', {});
    }

    changeEmail(payload) {
        return this.post('change-email', payload);
    }

    updateNeedChangeEmail(payload) {
        return this.post('update-need-change-email', payload);
    }

    registerEmail(payload) {
        return this.post('register-email', payload);
    }
    registerUser(payload) {
        let data = {...payload};
        delete data?.id;
        return this.post(`${payload?.id}/register`, data);
    }

    getUserConfirmation(userId) {
        return this.get(`${userId}/user`,{});
    }

    confirmEmail(payload) {
        return this.get('confirm-email', payload);
    }

    logOut(payload) {
        return this.get('logout', payload);
    }
}

export default AuthApi;